export const API_PATHS = {
  bfslOtpSend: "/api/v1/mobileotp/send",
  bfslOtpVerify: "/api/v1/mobileotp/validate",
  bfslSaveLead: "/api/v1/savelead",
  consentRead: "/api/v1/consent-read",
  consentInsert: "/api/v1/consent-insert",
  userDetails: "/api/v1/user/details",
  federatedLogin: "/api/v1/federated-login",
  federatedAuthorize: "/api/v1/federated-authorize",
  federatedBflWebLogin: "/api/v1/federated/bflweb-login",
  federatedBflWebAuthorize: "/api/v1/federated/bflweb-authorize",
  sendOtp: "/api/v2/login-oauth-otp",
  verifyOtp: "/api/v1/login-oauth-token",
  logout: "/api/v1/logout",
  verifyToken: "/api/v1/oauth-token-verify",
  verifySsoToken: "/api/v1/login-oauth-sso-token-verify",
  generatePerpetualToken: "/api/v1/generate/perpetual-token",
  leads: "/api/v1/trading/leads",
  GET_WATCHLIST_DATA: "/api/v1/trading/get-watchlist",
  UPDATE_WATCHLIST_DATA: "/api/v1/trading/update-watchlist",
  GET_HOLDINGS: "/api/v1/trading/holdings",
} as const;

export type ApiPathKeys = keyof typeof API_PATHS;
